export default {
  emptyMessage: {
    id: 'artistsFeed.emptyMessage',
    defaultMessage: 'Use the search box to find your favourite artists',
  },
};
